import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ListService, UserGroupUserListComponent, UserGroupUserListService } from '@spartacus/organization/administration/components';
import { EfaSubListComponent } from '../efa-sub-list/efa-sub-list.component';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'app-efa-user-group-user-list',
    templateUrl: './efa-user-group-user-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'content-wrapper' },
    providers: [
        {
            provide: ListService,
            useExisting: UserGroupUserListService,
        },
    ],
    imports: [EfaSubListComponent, RouterLink, TranslatePipe]
})
export class EfaUserGroupUserListComponent extends UserGroupUserListComponent implements OnInit {

  ngOnInit(): void {
  }

}
